import styled from 'styled-components';


export const ToggleSwitchBox = styled.label`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 20px;
  margin: 0px 10px;
`;